import getCorePersonalStore from "../stores/core/core-personal-store";
import { TCorePage, TPermissionID, TPermissionName } from "../Types";

const getPagePermission = (userPage: TCorePage): TPermissionName[] => {
  switch (userPage) {
    case "CORE_LOGIN":
      return ["NO_PERMISSION_NEEDED"];
    case "ALARMS":
      return ["Alarms"];
    case "CHANGE_PASSWORD":
      return [
        "CSR",
        "ShareHolder",
        "Developer",
        "Supervisor",
        "Auditor",
        "Alarms"
      ];
    case "APPROVAL_DATA":
      return ["Approve-Reject"];
    case "REPORTS":
      return ["Reports"];
    case "INVESTIGATION_CASES":
      return ["Investigation-Case"];
    case "USER_MESSAGES":
    case "USER_MESSAGE_ID":
    case "USER_CONVERSATIONS":
      return ["User-Messages"];
    case "USER_ADVANCED":
    case "USER_DEVICES":
    case "USER_EDIT_PROFILE":
    case "USER_EVENTS":
    case "USER_LOGIN":
    case "USER_PAYMENTS":
    case "USER_REFERRAL_CODE_USAGE":
    case "USER_PROMO_CODE_USAGE":
      return ["User"];
    case "USER_AI_DESCRIPTIONS":
      return ["SCSR"];
    case "CSR_MY_PERFORMANCE":
    case "CSR_MY_MISTAKES":
    case "CSR_MY_PREV_ACTIONS":
    case "CSR_MY_RECEIPT_EVENT_COUNT":
      return ["CSR"];
    case "AUDITOR_AUDIT":
    case "AUDITOR_AUDITED_EVENTS":
    case "AUDITOR_MY_AUDITING_PERFORMANCE":
    case "AUDITOR_MY_AUDITING_MISTAKES":
    case "AUDITOR_OTHER_CSR_PERFORMANCE":
    case "AUDITOR_EVENTS_CHARTS":
    case "AUDITOR_POOL":
    case "AUDITOR_WORKLOAD_DATA":
    case "AUDITOR_PROMO_CODE":
      return ["Auditor"];
    case "SUPERVISOR_PERMISSION":
    case "SUPERVISOR_SUPERVISE":
    case "SUPERVISOR_SUPERVISED_EVENTS":
      return ["Supervisor"];
    case "KHATTABAT_REMUNERATION":
    case "KHATTABAT_DATA_COLLECTION":
    case "SUPERVISOR_TURN_ON_OFF_KHATTABAT":
    case "SUPERVISOR_KHATTABAT_FUNNEL_STATS":
    case "KHATTABAT_MATCHMAKING_AUDIT":
    case "DEVELOPER_REASSIGN_KHATTABA":
      return ["Khattabat"];
    case "DEVELOPER_FLAGGED_CONNECTIONS":
    case "DEVELOPER_ON_CALL":
    case "DEVELOPER_WATCH_ALERT":
    case "DEVELOPER_BLOCKED_REQUESTS":
    case "DEVELOPER_AI_GENERATED_DESCRIPTION_ALL":
    case "DEVELOPER_TRANSFER_USER_PACKAGE":
      return ["Developer"];
    case "SHARE_HOLDER":
      return ["ShareHolder"];
    case "COMMUNICATIONS_ACCOUNTS_DELETION":
    case "COMMUNICATIONS_PROMO_CODE_GENERATOR":
      return ["Communications"];
    case "QA_CHANGE_STATUS_DATE":
    case "QA_CHANGE_EMAIL_SUBSCRIPTION":
      return ["QA"];
    default:
      return ["NO_PERMISSION_NEEDED"];
  }
};

export const getPermissionIDRequired = (
  userPermission: TPermissionName
): TPermissionID => {
  switch (userPermission) {
    case "User-Messages":
      return 3;
    case "Alarms":
      return 39;
    case "User":
      return 40;
    case "Approve-Reject":
      return 41;
    case "Reports":
      return 42;
    case "Investigation-Case":
      return 43;
    case "CSR":
      return 44;
    case "Auditor":
      return 45;
    case "Supervisor":
      return 46;
    case "ShareHolder":
      return 47;
    case "Developer":
      return 48;
    case "Communications":
      return 49;
    case "QA":
      return 50;
    case "Khatabat":
      return 51;
    case "SCSR":
      return 52;
    case "Khattabat":
      return 53;
    case "NO_PERMISSION_NEEDED":
      return -999999;
    default:
      return 0;
  }
};

export const hasSpecificRoutePermission = (condition: "ALL_ADMINS") => {
  switch (condition) {
    case "ALL_ADMINS":
      const userPermissions = getCorePersonalStore().userPermissions.get();
      return (
        userPermissions.indexOf(getPermissionIDRequired("Auditor")) > -1 ||
        userPermissions.indexOf(getPermissionIDRequired("Supervisor")) > -1
      );
    default:
      break;
  }
  return false;
};

const hasPermission = (userPage: TCorePage) => {
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const pagePermissions = getPagePermission(userPage);
  const permissionIDs = pagePermissions.map((permission) =>
    getPermissionIDRequired(permission)
  );
  const permissionGranted = permissionIDs.some((item) =>
    userPermissions.includes(item)
  );
  const hasPermission =
    permissionIDs.indexOf(-999999) > -1 ? true : permissionGranted;

  return hasPermission;
};
export default hasPermission;
